    <p-toolbar styleClass="">
      <ng-template pTemplate="left">
      </ng-template>

      <ng-template pTemplate="right">
        <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
                  pTooltip="Обновить таблицу документов" tooltipPosition="top"></p-button>

        <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                  pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

        <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                  pTooltip="Экспортировать  список документов" tooltipPosition="top" [disabled]="!totalValidOrders"></p-button>
      </ng-template>
    </p-toolbar>

    <p-table #ptable2 [value]="validOrdersList"
             [rows]="10"
             [rowsPerPageOptions]="[10,25,50]"
             [loading]="loading"
             [showCurrentPageReport]="true"
             [totalRecords]="totalValidOrders"
             [paginator]="true"
             currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
             sortMode="single"
             sortField="DOCVALDATE"
             sortOrder="1"
             dataKey="DOCID"
             selectionMode="single"
             [(selection)]="validSelectedDocument"
             (onRowSelect)="onValidRowSelect($event)"
             rowExpandMode="single"
             [rowHover]="true"
             [resizableColumns]="true"
             stateStorage="local"
             stateKey="dashboardOrders5-state"
             (onStateSave)="onStateSave($event)"
             (onStateRestore)="onStateRestoreActive($event)"
             (onFilter)="onFilterEvent($event)"
             styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn style="width: 5rem !important">...</th>
          <!--<th pResizableColumn style="width: 15%">Документ</th>-->
          <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: 11rem !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCDATE" style="width: 10rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCVALDATE" style="width: 10rem !important">Действителен до <p-sortIcon field="DOCVALDATE"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10% !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="AUTHOR" style="width: 10% !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="PARTNERNAMESTR" style="width: auto !important">Заказчик <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCSUM" style="width: 12rem !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 15% !important">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 15% !important">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
        </tr>
        <tr>
          <th pResizableColumn>...</th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['DOCNUMBER']" [class.hasvalue]="cf2['DOCNUMBER']" (input)="ptable2.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['DOCDATE']" [class.hasvalue]="cf2['DOCDATE']" (input)="ptable2.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['DOCVALDATE']" [class.hasvalue]="cf2['DOCVALDATE']" (input)="ptable2.filter($event.target.value, 'DOCVALDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['LOCALCOMP']" [class.hasvalue]="cf2['LOCALCOMP']" (input)="ptable2.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['AUTHOR']" [class.hasvalue]="cf2['AUTHOR']" (input)="ptable2.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['PARTNERNAMESTR']" [class.hasvalue]="cf2['PARTNERNAMESTR']" (input)="ptable2.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['DOCSUM']" [class.hasvalue]="cf2['DOCSUM']" (input)="ptable2.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['DOCNOTE1']" [class.hasvalue]="cf2['DOCNOTE1']" (input)="ptable2.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf2['DOCNOTE2']" [class.hasvalue]="cf2['DOCNOTE2']" (input)="ptable2.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-activeOrdersList let-expanded="expanded">
        <tr [pSelectableRow]="activeOrdersList"
            [class.futuredocs]="activeOrdersList.fd"
            [class.grayout]="activeOrdersList.go"
            [class.underline]="activeOrdersList.ps"
            [class.strikeout]="activeOrdersList.fs"
            [class.partiallypaiddoc]="activeOrdersList.pp"
            [class.notpaiddoc]="activeOrdersList.np"
            [class.fullypaiddoc]="activeOrdersList.fp"
            [class.todaydocuments]="activeOrdersList.td"
            [class.proformadoc]="(activeOrdersList.DOCTYPEID == 12)"
            [class.inorderdoc]="(activeOrdersList.DOCTYPEID == 2)"
            [class.banktransferdoc]="(activeOrdersList.DOCTYPEID == 9)"
            [class.purchorderdoc]="(activeOrdersList.DOCTYPEID == 10)"
            [class.yellowdoc]="(activeOrdersList.DOCTYPEID == 14)"
            [class.specdoc]="(activeOrdersList.DOCTYPEID == 7)"
            [class.shiporderdoc]="(activeOrdersList.DOCTYPEID == 4)"
            [class.invoicedoc]="(activeOrdersList.DOCTYPEID == 1)">
          <td style="max-width: 5rem !important; padding:0.75rem !important;">
            <button type="button" pButton pRipple [pRowToggler]="activeOrdersList"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
          </td>
          <td>
            <a [routerLink]="['/edit-document', activeOrdersList.DOCTYPEID, activeOrdersList.DOCID]">
              {{activeOrdersList.DOCNUMBER}}
            </a>
          </td>
          <td>{{activeOrdersList.DOCDATE  | date:'dd.MM.yyyy'}}</td>
          <td>{{activeOrdersList.DOCVALDATE  | date:'dd.MM.yyyy'}}</td>
          <td>{{activeOrdersList.LOCALCOMP}}</td>
          <td>{{activeOrdersList.AUTHOR}}</td>
          <td style="max-width: 450px !important">
            <a [routerLink]="['/edit-client', activeOrdersList.DOCCLIENTSID]">
              {{activeOrdersList.PARTNERNAMESTR}}
            </a>
          </td>
          <td style="text-align: right">{{activeOrdersList.DOCSUM | number:'1.2-2' }}</td>
          <td style="max-width: 15rem !important"><input pInputText type="text" [(ngModel)]="activeOrdersList.DOCNOTE1" readonly alt="{{activeOrdersList.DOCNOTE1}}"></td>
          <td style="max-width: 15rem !important"><input pInputText type="text" [(ngModel)]="activeOrdersList.DOCNOTE2" readonly alt="{{activeOrdersList.DOCNOTE2}}"></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-activeOrdersList>
        <tr>
          <td colspan="10">
            <div class="p-p-2">
              <app-document-content-table [selectedDocumentId]="activeOrdersList.DOCID" [showFooterTotal]="true"></app-document-content-table>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
          <td></td>
          <td></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10">На сегодня документов нет</td>
        </tr>
      </ng-template>
    </p-table>
